<ng-container *transloco="let t">
    <div class="single-order-status" [class.standalone]="standalone">
        <tui-svg
            *ngIf="OrderStateData[item.state].svg"
            [src]="OrderStateData[item.state].svg!"
            class="!w-8 !h-8 icon-custom"
        ></tui-svg>
        <tui-avatar
            *ngIf="OrderStateData[item.state].icon"
            class="!w-8 !h-8 avatar"
            [avatarUrl]="OrderStateData[item.state].icon!"
        ></tui-avatar>
        <div class="pr-8">
            <h3 class="text-base">
                {{ item.state === OrderState.Custom ? item.message : t(OrderStateData[item.state].label) }}
            </h3>
            <p *ngIf="item.state === OrderState.PaymentFailed && !!item.message" class="text-sm text-gray-600">
                {{ item.message }}
            </p>

            <p class="text-sm text-gray-600">{{ item.created_at! | dfnsParseIso | dfnsFormat : 'p, iiii P' }}</p>
        </div>
    </div>
</ng-container>
